class FilterFacet extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.toggleSummary = this.toggleSummary.bind(this)
    this.clickOutside = this.clickOutside.bind(this)

    this.listeners.add(this, 'click', this.toggleSummary)

    this.listeners.add(document.body, 'click', this.clickOutside)
  }

  clickOutside (e) {
    // If the click was on the facet summary or content, do nothing.
    if (this.contains(e.target)) {
      return
    }

    this.content.setAttribute('aria-hidden', 'true')
  }

  toggleSummary () {
    this.closeAllSummaries()

    this.content.setAttribute('aria-hidden', 'false')
  }

  closeAllSummaries () {
    const summaries = document.querySelectorAll('filter-facet')

    summaries.forEach(summary => {
      summary.content.setAttribute('aria-hidden', 'true')
    })
  }

  get content () {
    return window.BAO.Utils.getElement(this.els.content.selector, {
      context: this
    })
  }
}

if (!customElements.get('filter-facet')) {
  customElements.define('filter-facet', FilterFacet)
}
